module.exports = "<div nv-l1-course-header=\"\" header-title=\"{{ ::vm.TeamWorkspaceManager.currentTeam.name }}\"></div>";